var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 48,
    height: 15,
    fill: "#fff",
    stroke: "#828385",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.47,4.05H20l3,4.79h0V4.05H24.5v7.13H22.93L20,6.41h0v4.77H18.47Z",
    fill: "#828385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.24,5.88a2.54,2.54,0,0,1,2.68,2.73,2.54,2.54,0,0,1-2.68,2.72,2.53,2.53,0,0,1-2.67-2.72A2.54,2.54,0,0,1,28.24,5.88Zm0,4.37c1,0,1.26-.82,1.26-1.64S29.21,7,28.24,7,27,7.78,27,8.61,27.28,10.25,28.24,10.25Z",
    fill: "#828385"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOutline);
export default __webpack_public_path__ + "static/media/NoOutline.c6da4567b4089c66c23a8c5f40d7f0ba.svg";
export { ForwardRef as ReactComponent };